import React from 'react'
import './SharePlugin.scss'
import { useSelector } from 'react-redux'

function SharePlugin() {

  const blogPageTheme = useSelector(state => state.GetBlogPageThemeReducer)
  const theme = blogPageTheme?.blogTheme

  var socialMediaShareMap = {
    "facebook": "https://www.facebook.com/sharer/sharer.php?u=",
    "twitter": "http://twitter.com/share?url=",
    "linkedin": "http://www.linkedin.com/shareArticle?mini=true&url="
  }

  function shareWindow(event) {
    var url = window.location.href;
    var socialMediaShareURL = socialMediaShareMap[event.currentTarget.value]
    window.open(socialMediaShareURL + encodeURIComponent(url), '', 'left=500,top=100,width=500,height=600,personalbar=0,toolbar=0,scrollbars=0,resizable=0');
  }

  return (
    <>
      {theme.floatingSharePlugin == "true" ?
        <div class="share-plugin-float">
          <div class="social">
            <button className="soc-facebook soc-icon" onClick={shareWindow} value='facebook' >
              <i className="bi bi-facebook" ></i>
            </button>

            <button className="soc-twitter soc-icon" onClick={shareWindow} value='twitter' >
              <i className="bi bi-twitter" ></i>
            </button>

            <button className="soc-linkedin soc-icon" onClick={shareWindow} value='linkedin' >
              <i className="bi bi-linkedin" ></i>
            </button>

          </div>
        </div>
        :
        <div className="share-plugin" >

          <div className="title" style={{ fontWeight: 'bold', margin: '10px' }}>
            <i className="bi bi-share" style={{ fontSize: '15px', margin: '13px' }}></i>
            Share this : </div>
          <div className="social-sidebar-container" style={{ display: 'flex' }}>
            <ul className="social-sidebar" style={{ listStyleType: 'none', gap: '30px', display: 'flex' }}>

              <button className="soc-facebook soc-icon" onClick={shareWindow} value='facebook' >
                <i className="bi bi-facebook" ></i>
                <p>Facebook</p>
              </button>

              <button className="soc-twitter soc-icon" onClick={shareWindow} value='twitter'>
                <i className="bi bi-twitter" ></i>
                <p>Twitter</p>
              </button>

              <button className="soc-linkedin soc-icon" onClick={shareWindow} value='linkedin'>
                <i className="bi bi-linkedin" ></i>
                <p>LinkedIn</p>
              </button>

            </ul>
          </div>
        </div>
      }
    </>

  )
}

export default SharePlugin
